var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"CyWithoutCodeLogin"},[_c('van-empty',{attrs:{"image":"error","description":"链接已失效，请退出此页面"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }